export enum BroadcastMessageKeysEnum {
  Homepage = 'homepage',
}
